// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.glow {
  font-size: 70px;
  font-weight: bold;
  font-family: "Poppins", sans-serif; /* Choose your preferred font */
  background-image: linear-gradient(
    to right top,
    #ccc5c5,
    #d2cdcf,
    #d9d6d8,
    #dfdfe0,
    #e7e7e7
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  /* animation: gradientAnimation 10s linear infinite; */
  text-align: center;
}
@keyframes gradientAnimation {
  0% {
    background-position: 0% 100%;
  }
  100% {
    background-position: 100% 0%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/css/common/glow.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,kCAAkC,EAAE,+BAA+B;EACnE;;;;;;;GAOC;EACD,6BAA6B;EAC7B,oCAAoC;EACpC,sDAAsD;EACtD,kBAAkB;AACpB;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".glow {\n  font-size: 70px;\n  font-weight: bold;\n  font-family: \"Poppins\", sans-serif; /* Choose your preferred font */\n  background-image: linear-gradient(\n    to right top,\n    #ccc5c5,\n    #d2cdcf,\n    #d9d6d8,\n    #dfdfe0,\n    #e7e7e7\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  /* animation: gradientAnimation 10s linear infinite; */\n  text-align: center;\n}\n@keyframes gradientAnimation {\n  0% {\n    background-position: 0% 100%;\n  }\n  100% {\n    background-position: 100% 0%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
